// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"app_wrapper__1cLF6","content":"app_content__3V6TH","sidebar":"app_sidebar__1HDQH","activityIndicator":"app_activityIndicator__1Q-Ch"};